<div class="report__wrapper">

  <div class="report__header">
    <mat-form-field appearance="outline" class="report__select">
      <mat-label>{{ 'certificateCreator.placeholder' | translate }}</mat-label>
      <mat-select [(ngModel)]="zeugnis.artDesZeugnis" (selectionChange)="onCertificateTypeChange()" id="zA"
                  required #artDesZeugnisField="ngModel">
        @for (zA of certificateTypes; track zA) {
          <mat-option [value]="zA.value">{{ zA.label | translate }}</mat-option>
        }
      </mat-select>
      @if (artDesZeugnisField.invalid && (artDesZeugnisField.touched || downloadAttempted)) {
        <mat-error>{{ 'certificateCreator.certificateInputs.certificateTypeRequired' | translate }}</mat-error>
      }
    </mat-form-field>

    <mat-form-field appearance="outline">
      <mat-label>{{ 'certificateCreator.certificateInputs.language' | translate }}</mat-label>
      <mat-select [(ngModel)]="language" (selectionChange)="changeLanguage()">
        <mat-option value="de">{{ 'certificateCreator.certificateInputs.german' | translate }}</mat-option>
        <mat-option value="en">{{ 'certificateCreator.certificateInputs.english' | translate }}</mat-option>
      </mat-select>
    </mat-form-field>

    @if (isWorkCertificate()) {
      <mat-form-field appearance="outline">
        <mat-label>{{ 'certificateCreator.sections.endDate' | translate }}</mat-label>
        <input matInput
               [matDatepicker]="dpEnd"
               [ngModel]="endDateMoment"
               (dateChange)="onEndDateChange($event.value)"
               placeholder="TT.MM.JJJJ"
               id="enddatum"
               required
               #endDateField="ngModel" />
        <mat-datepicker-toggle matIconSuffix [for]="dpEnd"></mat-datepicker-toggle>
        <mat-datepicker #dpEnd></mat-datepicker>
        @if (endDateField.invalid && (endDateField.touched || downloadAttempted)) {
          <mat-error>{{ 'certificateCreator.sections.endDateRequired' | translate }}</mat-error>
        }
      </mat-form-field>
    }

    <button mat-flat-button (click)="downloadCertificate()" class="report__download-btn"
            [disabled]="isDownloadDisabled()">
      {{ 'certificateCreator.certificateInputs.download' | translate }}
    </button>
  </div>

  <div class="form-section">
    <h2 class="report__headline">{{ 'certificateCreator.headers.introduction' | translate }}</h2>
    <div class="report__input-data">
      <mat-form-field class="form-field">
        <mat-label>{{ 'certificateCreator.certificateInputs.title' | translate }}</mat-label>
        <mat-select [(ngModel)]="zeugnis.anrede" id="anrede">
          @for (an of salutations; track an) {
            <mat-option [value]="an.value">{{ an.label | translate }}</mat-option>
          }
        </mat-select>
      </mat-form-field>
      <mat-form-field>
        <mat-label>{{ 'certificateCreator.certificateInputs.firstname' | translate }}</mat-label>
        <input matInput [(ngModel)]="zeugnis.vorname" id="vorname" required #vornameField="ngModel" />
        @if (vornameField.invalid && (vornameField.touched || downloadAttempted)) {
          <mat-error>{{ 'certificateCreator.certificateInputs.firstnameRequired' | translate }}</mat-error>
        }
      </mat-form-field>
      <mat-form-field>
        <mat-label>{{ 'certificateCreator.certificateInputs.lastname' | translate }}</mat-label>
        <input matInput [(ngModel)]="zeugnis.nachname" id="nachname" required #nachnameField="ngModel" />
        @if (nachnameField.invalid && (nachnameField.touched || downloadAttempted)) {
          <mat-error>{{ 'certificateCreator.certificateInputs.lastnameRequired' | translate }}</mat-error>
        }
      </mat-form-field>
      <mat-form-field>
        <mat-label>{{ 'certificateCreator.certificateInputs.birthDate' | translate }}</mat-label>
        <input matInput
               [matDatepicker]="dpBirth"
               [ngModel]="birthDateMoment"
               [max]="today"
               (dateChange)="onBirthDateChange($event.value)"
               placeholder="TT.MM.JJJJ"
               id="dateOfBirth" />
        <mat-datepicker-toggle matIconSuffix [for]="dpBirth"></mat-datepicker-toggle>
        <mat-datepicker #dpBirth></mat-datepicker>
      </mat-form-field>
      <mat-form-field>
        <mat-label>{{ 'certificateCreator.certificateInputs.hireDate' | translate }}</mat-label>
        <input matInput
               [matDatepicker]="dpHire"
               [ngModel]="hireDateMoment"
               (dateChange)="onHireDateChange($event.value)"
               placeholder="TT.MM.JJJJ"
               id="einstellungsdatum"
               required
               #hireDateField="ngModel" />
        <mat-datepicker-toggle matIconSuffix [for]="dpHire"></mat-datepicker-toggle>
        <mat-datepicker #dpHire></mat-datepicker>
        @if (hireDateField.invalid && (hireDateField.touched || downloadAttempted)) {
          <mat-error>{{ 'certificateCreator.certificateInputs.hireDateRequired' | translate }}</mat-error>
        }
      </mat-form-field>
      <mat-form-field class="report__company">
        <mat-label>{{ 'certificateCreator.certificateInputs.company' | translate }}</mat-label>
        <mat-select [(ngModel)]="zeugnis.firma" id="firma">
          @for (fir of companies; track fir) {
            <mat-option [value]="fir.value">{{ fir.label }}</mat-option>
          }
        </mat-select>
      </mat-form-field>
    </div>
    <div class="report__input-data">
      <mat-form-field class="report__role">
        <mat-label>{{ 'certificateCreator.certificateInputs.role' | translate }}</mat-label>
        <input matInput [(ngModel)]="zeugnis.rolle" id="rolle" required #rolleField="ngModel" />
        @if (rolleField.invalid && (rolleField.touched || downloadAttempted)) {
          <mat-error>{{ 'certificateCreator.certificateInputs.roleRequired' | translate }}</mat-error>
        }
      </mat-form-field>
    </div>
  </div>

  <div class="report__preview">
    @if (language === 'en') {
      <p>
        @if (isWorkCertificate()) {
          {{ zeugnis.anrede | salutation:'en' }} {{ zeugnis.vorname }} {{ zeugnis.nachname }}@if (zeugnis.dateOfBirth) {, born on {{ zeugnis.dateOfBirth | date:'dd.MM.yyyy' }}}, was employed as a {{ zeugnis.rolle }}
          at {{ zeugnis.firma }} from {{ zeugnis.einstellungsdatum }}.
        } @else {
          {{ zeugnis.anrede | salutation:'en' }} {{ zeugnis.vorname }} {{ zeugnis.nachname }}@if (zeugnis.dateOfBirth) {, born on {{ zeugnis.dateOfBirth | date:'dd.MM.yyyy' }}}, has been working as a {{ zeugnis.rolle }}
          at the {{ zeugnis.firma }} since {{ zeugnis.einstellungsdatum }}.
        }
      </p>
      <p>
        The {{ zeugnis.firma }} is an agile consulting firm specializing in software quality assurance,
        offering services ranging from requirements analysis to productive deployment,
        with a particular focus on automated software testing.
      </p>
    } @else {
      <p>
        @if (isWorkCertificate()) {
          {{ zeugnis.anrede }} {{ zeugnis.vorname }} {{ zeugnis.nachname }}@if (zeugnis.dateOfBirth) {, geboren am {{ zeugnis.dateOfBirth | date:'dd.MM.yyyy' }}}, war seit dem
          {{ zeugnis.einstellungsdatum }} als {{ zeugnis.rolle }} bei der
          {{ zeugnis.firma }} tätig.
        } @else {
          {{ zeugnis.anrede }} {{ zeugnis.vorname }} {{ zeugnis.nachname }}@if (zeugnis.dateOfBirth) {, geboren am {{ zeugnis.dateOfBirth | date:'dd.MM.yyyy' }}}, ist seit dem
          {{ zeugnis.einstellungsdatum }} als {{ zeugnis.rolle }} bei der
          {{ zeugnis.firma }} tätig.
        }
      </p>
      <p>
        Die {{ zeugnis.firma }} ist ein agiles Beratungshausunternehmen, welches
        sich auf die Softwarequalitätssicherung spezialisiert hat und
        Dienstleistungen von der Anforderungsanalyse bis zum Produktiveinsatz,
        im speziellen für das automatisierte Software Testen, anbietet.
      </p>
    }
  </div>

  <h2 class="report__headline">{{ 'certificateCreator.headers.technicalTasks' | translate }}</h2>
  <div class="report__input-data">
    <mat-form-field class="report__role">
      <mat-label>{{ 'certificateCreator.certificateInputs.lastProjectRole' | translate }}</mat-label>
      <input matInput [(ngModel)]="zeugnis.letzteProjektrolle" id="letzteProjektrolle" required #lastProjectRoleField="ngModel" />
      @if (lastProjectRoleField.invalid && (lastProjectRoleField.touched || downloadAttempted)) {
        <mat-error>{{ 'certificateCreator.certificateInputs.lastProjectRoleRequired' | translate }}</mat-error>
      }
    </mat-form-field>
  </div>
  <div class="report__preview">
    @if (language === 'en') {
      <p>
        In {{ zeugnis.anrede | possessiv:language }} role as a {{ zeugnis.letzteProjektrolle }},
        {{ zeugnis.anrede | salutation:'en' }} {{ zeugnis.vorname }} {{ zeugnis.nachname }}
        @if (isWorkCertificate()) { primarily performed } @else { primarily performs }
        the following tasks:
      </p>
    } @else {
      <p>
        In {{ zeugnis.anrede | possessiv:language }} Funktion als
        {{ zeugnis.letzteProjektrolle }}
        @if (isWorkCertificate()) { nahm } @else { nimmt }
        {{ zeugnis.anrede }} {{ zeugnis.vorname }} {{ zeugnis.nachname }}
        im Wesentlichen folgende Aufgaben wahr:
      </p>
    }
    <ul>
      @for (task of zeugnis.aufgaben; track task) {
        <li>{{ task }}</li>
      }
    </ul>
  </div>

  <h2 class="report__headline">{{ 'certificateCreator.headers.technicalSkills' | translate }}</h2>
  <div class="report__preview">
    @if (language === 'en') {
      <p>The methodologies and tools {{ zeugnis.anrede | reflexiv:language }}
        @if (isWorkCertificate()) { used } @else { uses } are:</p>
    } @else {
      <p>Die von {{ zeugnis.anrede | reflexiv:language }} angewandten Methodiken und
        Werkzeuge
        @if (isWorkCertificate()) { waren: } @else { sind: }
      </p>
    }
    <p>{{ zeugnis.werkzeuge.join(', ') }}</p>
  </div>

  @for (category of categories; track category.field) {
    <div class="report__section">
      <h2 class="report__headline">{{ category.labelKey | translate }}</h2>

      @for (group of category.groups; track group.note) {
        <div class="report__note-group">
          <span class="report__note-label">
            {{ 'certificateCreator.sections.grade' | translate }} {{ group.note }}
          </span>
          <div class="report__report-button">
            @for (block of group.blocks; track block.variant) {
              <button
                mat-raised-button
                [class.report__button--active]="getCertificateField(category.field) === block.text"
                (click)="setCertificateField(category.field, block.text)"
              >
                {{ block.text }}
              </button>
            }
          </div>
        </div>
      }

      <div class="report__preview">
        <p>
          {{ getPreviewText(category.field) | gendered: zeugnis.anrede : zeugnis.nachname : language }}
        </p>
      </div>
    </div>
  }

</div>
